import useIsomorphicLayoutEffect from 'hooks/useIsomorphicLayoutEffect'
import useTimeline from 'hooks/useTimeline'
import useSetStyle from 'hooks/useSetStyle'
import useTimelinePlayback from 'hooks/useTimelinePlayback'

const usePanelAnimations = (
  isOpen,
  { panelRef, backgroundRef, contentRef, fromTop = true }
) => {
  const setPanelStyle = useSetStyle(panelRef)

  const openPanelTl = useTimeline({ paused: true }, (tl) => {
    tl.fromTo(
      panelRef.current,
      {
        autoAlpha: 0,
      },
      {
        autoAlpha: 1,
        duration: 0.1,
        ease: 'none',
      },
      '+=0.1'
    )

    tl.fromTo(
      backgroundRef.current,
      {
        scaleY: 0,
        transformOrigin: 'top',
      },
      {
        force3D: true,
        scaleY: 1,
        transformOrigin: 'top',
        ease: 'elastic.out(0.3, 0.3)',
        duration: 0.8,
      },
      '-=0.1'
    )

    tl.fromTo(
      panelRef.current,
      {
        yPercent: 20 * (fromTop ? -1 : 1),
        z: -50,
      },
      {
        yPercent: 0,
        z: 0,
        ease: 'elastic.out(0.3, 0.3)',
        duration: 0.8,
      },
      '-=0.8'
    )

    tl.fromTo(
      contentRef.current,
      { opacity: 0 },
      { opacity: 1, ease: 'none', duration: 0.4 },
      '-=0.7'
    )
  })

  useIsomorphicLayoutEffect(() => {
    if (isOpen) {
      openPanelTl.timeScale(1.4)
      setPanelStyle({ zIndex: 1 })
    } else {
      openPanelTl.timeScale(3)
      setPanelStyle({ zIndex: 0 })
    }
  }, [isOpen])

  useTimelinePlayback(openPanelTl, isOpen)
}

export default usePanelAnimations
